import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
Vue.filter('replenish2', function (value) {
  if (!value) return ''
  value = value + '';
  if (value.length == 1) {
    return '0' + value;
  } else {
    return value;
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");